import axios from "axios";
export default {
  data() {
    return {
      dialog_nuovo: false,
      id_prodotto_sel: null,
      tab_loading: false,
      isLoading: false,
      loading_invio: false,
      items: [],
      search: null,
      avviso_exist: false,
      url_json: "",
      loading_url: false,
      scraping_url: false,
      avviso_scraping_error: false,
      scraping_error_message: "",
      sorgente_info: null,
    };
  },
  mounted() {
    let url =
      process.env.VUE_APP_API_ROOT + "/admin/get_fitofarmaco_url";
    let auth = this.$store.getters.get_credential;
    axios
      .get(url, { "auth": auth })
      .then((res) => {
        this.url_json = res.data.url;
      })
      .catch(() => {
      });
  },
  watch: {
    search(val) {
      // Items have already been loaded
      if (!val || val.length < 3) {
        return;
      }
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;

      // Lazily load input items
      let url = process.env.VUE_APP_API_ROOT + "/admin/fitofarmaco/" + this.search;
      let auth = this.$store.getters.get_credential;
      axios
        .get(url, { auth: auth })
        .then((res) => {
          this.items = res.data;
        })
        .catch(() => {
        })
        .finally(() => (this.isLoading = false));
    },
  },
  computed: {
    fitof_select() {
      return this.items.find((fito) => fito._id.$oid == this.id_prodotto_sel);
    },
    fitofarmaci_magazzino() {
      return this.$store.getters.get_fitofarmaci.sort((a, b) =>
        a.dettagli.prodotto.localeCompare(b.dettagli.prodotto)
      );
    },
  },
  methods: {
    aggiungi_prodotto_fito() {
      this.loading_invio = true;
      this.$store
        .dispatch("add_prodotto_fito", this.id_prodotto_sel)
        .then((res) => {
          this.loading_invio = false;
          if (res == "exist") {
            this.avviso_exist = true;
          } else {
            this.dialog_nuovo = false;
          }
        });
    },
    fito_update_url() {
      this.loading_url = true;
      let url =
        process.env.VUE_APP_API_ROOT +
        "/admin/set_fitofarmaco_url";
      let auth = this.$store.getters.get_credential;
      axios
        .post(url, { url: this.url_json }, { "auth": auth })
        .then(() => {
          this.loading_url = false;
        })
        .catch(() => {
        });
    },
    // Tenta di individuare l'URL aggiornato del dataset ministeriale
    // (scraping della pagina open data, non un'API ufficiale: può fallire).
    scopri_url_fitofarmaci() {
      this.scraping_url = true;
      this.avviso_scraping_error = false;
      this.sorgente_info = null;
      let url =
        process.env.VUE_APP_API_ROOT + "/admin/qdc/scopri_url_fitofarmaci";
      let auth = this.$store.getters.get_credential;
      axios
        .get(url, { auth: auth })
        .then((res) => {
          this.scraping_url = false;
          if (res.data.res == "ok") {
            this.url_json = res.data.url;
            this.sorgente_info = {
              data_aggiornamento: res.data.data_aggiornamento,
              frequenza_aggiornamento: res.data.frequenza_aggiornamento,
              unita_organizzativa: res.data.unita_organizzativa,
            };
          } else {
            this.scraping_error_message = res.data.message;
            this.avviso_scraping_error = true;
          }
        })
        .catch(() => {
          this.scraping_url = false;
          this.scraping_error_message =
            "Impossibile contattare il server per il rilevamento automatico dell'URL";
          this.avviso_scraping_error = true;
        });
    },
  },
};
